module.exports = __webpack_public_path__ + "static/media/vf_wtop_core.775241c1.svg";